import { NgModule, Optional, SkipSelf,OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnsureModuleLoadedOnceGuard } from './guards/ensure-module-load-once.guard';
import { environment } from '../../environments/environment';
import { MsalService, MSAL_INSTANCE, MsalGuard, MsalInterceptor, MsalBroadcastService } from './msal';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { MsalGuardConfiguration } from './msal/msal.guard.config';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import {TranslateModule, TranslateLoader, TranslatePipe} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';


const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({  
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: function(http: HttpClient) { return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');},
          deps: [HttpClient],
      },
      defaultLanguage: 'es'
    }),
    ],
    providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
      },
      {
        provide: MSAL_INSTANCE,
        useFactory: function (): IPublicClientApplication {
          let client = new PublicClientApplication({
            auth: {
              authority: environment.openId.authority,
              clientId: environment.openId.clientID,
              redirectUri: environment.openId.redirectUri,
              postLogoutRedirectUri: environment.openId.logoutRedirectUri
            },
            cache:{
              cacheLocation:'localStorage',
              storeAuthStateInCookie:false
            }
          });
          return client;
        }
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useValue: {
          interactionType: InteractionType.Redirect
        } as MsalGuardConfiguration
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: function(): MsalInterceptorConfig {
          const protectedResourceMap = new Map<string, Array<string>>()
          protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read'])
          protectedResourceMap.set(environment.urlServerApi, [environment.scopeServerApi])
          protectedResourceMap.set(environment.urlAudioApi, [environment.scopeAudioApi])
          return {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: protectedResourceMap
          }
        }
      },
      MsalService,
      MsalGuard,
      MsalBroadcastService,
    ],
    exports:[
      TranslateModule
    ],
    declarations: []
})
export class CoreModule  extends EnsureModuleLoadedOnceGuard implements OnInit {

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    @Optional() @SkipSelf() parentModule:CoreModule){
    super(parentModule);
  }

  ngOnInit() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest});
    } else {
      this.authService.loginRedirect();
    }
  }
 }
